import React, { useContext, useMemo } from "react";
import clsx from "clsx";

import { Context } from "../../../../teacherStore";
import { getStudentAnswersByQuestion } from "../../../../libs/ActiveLearning";
import styles from "../ActiveLearningLessonAnswerData.module.scss";

interface ILesson15Pros {
  materialCode: string;
  lessonNo: number;
}

export const Lesson15: React.FC<ILesson15Pros> = ({
  materialCode,
  lessonNo,
}) => {
  const { state } = useContext(Context);
  const activeLearningStudentAnswers = state.active_learning_student_answers;

  const answersL12I1Q1 = useMemo(() => {
    const answers = getStudentAnswersByQuestion(
      materialCode,
      activeLearningStudentAnswers,
      lessonNo,
      1,
      1,
    );

    return answers.length > 0
      ? answers.map(answer => answer.contents.value).join("")
      : "回答データがありません。";
  }, [materialCode, activeLearningStudentAnswers, lessonNo]);

  const answersL12I2Q1 = useMemo(() => {
    const answers = getStudentAnswersByQuestion(
      materialCode,
      activeLearningStudentAnswers,
      lessonNo,
      2,
      1,
    );

    return answers.length > 0
      ? answers.map(answer => answer.contents.value).join("")
      : "回答データがありません。";
  }, [materialCode, activeLearningStudentAnswers, lessonNo]);

  const answersL12I3Q1 = useMemo(() => {
    return getStudentAnswersByQuestion(
      materialCode,
      activeLearningStudentAnswers,
      lessonNo,
      3,
      1,
    );
  }, [materialCode, activeLearningStudentAnswers, lessonNo]);

  const answersL12I3Q2 = useMemo(() => {
    const answers = getStudentAnswersByQuestion(
      materialCode,
      activeLearningStudentAnswers,
      lessonNo,
      3,
      2,
    );

    if (answers.length > 0) {
      const [answer] = answers;
      const parentUid = answer.contents.parentUid;
      return answersL12I3Q1.find(answer => answer.contents.uid === parentUid)
        ?.contents.value;
    } else {
      return "回答データがありません。";
    }
  }, [materialCode, activeLearningStudentAnswers, answersL12I3Q1, lessonNo]);

  const answersL12I3Q3 = useMemo(() => {
    const answers = getStudentAnswersByQuestion(
      materialCode,
      activeLearningStudentAnswers,
      lessonNo,
      3,
      3,
    );

    return answers.length > 0
      ? answers.map(answer => answer.contents.value).join("")
      : "回答データがありません。";
  }, [materialCode, activeLearningStudentAnswers, lessonNo]);

  const answersL12I4Q1 = useMemo(() => {
    const answers = getStudentAnswersByQuestion(
      materialCode,
      activeLearningStudentAnswers,
      lessonNo,
      4,
      1,
    );

    return answers.length > 0
      ? answers.map(answer => answer.contents.value).join("")
      : "回答データがありません。";
  }, [materialCode, activeLearningStudentAnswers, lessonNo]);

  const answersL12I5Q1 = useMemo(() => {
    const answers = getStudentAnswersByQuestion(
      materialCode,
      activeLearningStudentAnswers,
      lessonNo,
      5,
      1,
    );

    return answers.length > 0
      ? answers.map(answer => answer.contents.value).join("")
      : "回答データがありません。";
  }, [materialCode, activeLearningStudentAnswers, lessonNo]);

  return (
    <div className={styles.lesson}>
      <p className={styles.title}>
        Lesson{lessonNo < 10 ? `0${lessonNo}` : lessonNo}{" "}
        自分の成長と未来について考えよう
      </p>
      <div className={styles.inner}>
        <div className={styles.work}>
          <p className={styles.no}>WORK01</p>
          <div className={styles.question}>
            <p className={styles.heading}>
              自分が興味・関心を持って取り組めたことや学びになったことを振り返ろう。
            </p>
            <p className={clsx(styles.answer, styles.high)}>{answersL12I1Q1}</p>
          </div>
        </div>
        <div className={styles.work}>
          <p className={styles.no}>WORK02</p>
          <div className={styles.question}>
            <p className={styles.heading}>改善点を振り返ろう。</p>
            <p className={clsx(styles.answer, styles.high)}>{answersL12I2Q1}</p>
          </div>
        </div>
        <div className={styles.work}>
          <p className={styles.no}>WORK03</p>
          <div className={styles.question}>
            <p className={styles.heading}>
              考えた課題解決ストーリーを社会で実現するとしたら、どんな仕事に関わりそうかを考えよう。
            </p>
            {answersL12I3Q1.length > 0 ? (
              answersL12I3Q1.map(answer => (
                <p key={answer.id} className={styles.answer}>
                  {answer.contents.value}
                </p>
              ))
            ) : (
              <p className={styles.answer}>回答データがありません。</p>
            )}
          </div>
          <div className={styles.question}>
            <div className={clsx(styles.heading, styles.dot)}>
              考えた仕事の中で一番「やってみたい」と思った仕事を選ぼう。
            </div>
            <p className={styles.answer}>{answersL12I3Q2}</p>
          </div>
          <div className={styles.question}>
            <div className={clsx(styles.heading, styles.dot)}>
              その仕事によって、誰にどんな価値や感情を届けられそうかを考えよう。
            </div>
            <p className={clsx(styles.answer, styles.high)}>{answersL12I3Q3}</p>
          </div>
        </div>
        <div className={styles.work}>
          <p className={styles.no}>WORK04</p>
          <div className={styles.question}>
            <p className={styles.heading}>
              成長できたと思う部分を考えてみよう。
            </p>
            <p className={clsx(styles.answer, styles.high)}>{answersL12I4Q1}</p>
          </div>
        </div>
        <div className={styles.work}>
          <p className={styles.no}>WORK05</p>
          <div className={styles.question}>
            <p className={styles.heading}>
              今回学んだことで分かった自分の強みや、今後やってみたい、伸ばしていきたいと思うことを考えよう。
            </p>
            <p className={clsx(styles.answer, styles.high)}>{answersL12I5Q1}</p>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Lesson15;
